/**
 * @file paddlejs bullets
 * @author wanzhongyun
 */

import React, { useEffect, useRef, useState } from 'react';
import Danmaku from 'rc-danmaku';
import { useMount } from 'react-use';
import { clearInterval } from 'timers';
import { IBulletsProps } from './../../type';

import './style.less';

const PaddleJSBullets: React.FC<IBulletsProps> = props => {

    const { status } = props;
    const danmakuInsRef = useRef<Danmaku | null>(null);
    const [intervalTimer, setIntervalTimer] = useState<number>(6000);

    useMount(() => {
        const danmakuIns = new Danmaku('.danmaku-wrapper', {
            maxRow: 10
        });
        danmakuInsRef.current = danmakuIns;
        let timer: any = null;
        timer = setInterval(() => setIntervalTimer(num => num + 1), intervalTimer);
        return () => {
            clearInterval(timer);
        }
    });

    useEffect(() => {
        if (danmakuInsRef.current && status) {
            const exampleWord = ['Paddle Cloud', 'Paddle Lite', 'Paddle.js', 'Paddle Serving', 'Paddle Inference', 'Paddle Detection', 'Paddle Hub', 'Paddle X', 'PaddleSeg', 'Paddle OCR'];
            exampleWord.forEach(item => {
                if (danmakuInsRef.current) {
                    danmakuInsRef.current.speed = (Math.floor(Math.random() * 60) + 70);
                    danmakuInsRef.current?.push(item, {
                        color: ['#87ceeb', 'pink', '#fafff0', '#40e0d0'][Math.floor(Math.random() * 4)]
                    });
                }
                
            });
        }
    }, [status, intervalTimer]);

    return (
        <div className="paddle-js-danmaku">
            <div className="danmaku-wrapper" />
        </div>
    );
};

export default PaddleJSBullets;